import { Box, Typography } from '@mui/material'
import React from 'react'

interface HeaderProps {
  title?: string | null | React.ReactElement
  icon?: React.ReactElement
  extra?: React.ReactElement
}

const Header: React.FC<HeaderProps> = ({ title = null, icon = undefined, extra = undefined }) => (
  <Box
    sx={theme => ({
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'flex-start'
      }
    })}
  >
    <Box
      sx={theme => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        [theme.breakpoints.down('md')]: {
          marginBottom: '5px'
        }
      })}
    >
      {icon && <Box sx={{ display: 'flex', marginRight: '5px' }}>{icon}</Box>}
      <Typography>{title}</Typography>
    </Box>
    <Box>{extra}</Box>
  </Box>
)

export default Header
